import {createAsyncThunk} from '@reduxjs/toolkit';
import type {
  InitEmailMarketingCampaignPerformanceArg,
  InitEmailMarketingCampaignPerformanceResponse,
  RemoveInvalidEmailsArg,
} from './email-marketing-campaign-performance.types';

export const initEmailMarketingCampaignPerformance = createAsyncThunk(
  'initEmailMarketingCampaignPerformance',
  async (data: InitEmailMarketingCampaignPerformanceArg): Promise<InitEmailMarketingCampaignPerformanceResponse> => {
    return (await window.PMW.readLocal('emailmarketing/initEmailMarketingCampaignPerformance', data)) as InitEmailMarketingCampaignPerformanceResponse;
  }
);

export const removeInvalidEmailsForCampaign = createAsyncThunk(
  'removeInvalidEmailsForCampaign',
  async (data: RemoveInvalidEmailsArg): Promise<void> => {
    await window.PMW.writeLocal('emailmarketing/removeInvalidEmailsForCampaign', data);
  }
);

export const removeInvalidEmailsForMailingList = createAsyncThunk(
  'removeInvalidEmailsForMailingList',
  async (data: RemoveInvalidEmailsArg): Promise<void> => {
    await window.PMW.writeLocal('emailmarketing/removeInvalidEmailsForMailingList', data);
  }
);
